import type { CreateRenderLeaf } from '../../types';
import type { DictationPluginPropertyOptions } from './types';

export const renderLeafDictation: CreateRenderLeaf<DictationPluginPropertyOptions> = ({
  component: Component,
  pluginID,
}) => {
  const renderLeaf: ReturnType<CreateRenderLeaf<DictationPluginPropertyOptions>> = ({
    leaf,
    children,
    ...rest
  }) => {
    const leafRecord = leaf as unknown as Record<string, unknown>;
    if (typeof pluginID === 'string' && leafRecord[pluginID] != null && leaf.text != null) {
      return <Component data-editor-leaf={pluginID} leaf={leaf} children={children} {...rest} />;
    }

    return children;
  };

  return renderLeaf;
};
